import { FC, memo, useState } from 'react';
import Blocks from '../../components/Blocks/Blocks';
import SiteMenu from '../../components/SiteMenu/SiteMenu';
import { IncomingCalls } from '../../components/Calls/IncomingCalls/IncomingCalls';
import { IncomingCallsFilter } from '../../components/Calls/IncomingCalls/IncomingCallsFilter/IncomingCallsFilter';
import { IncomingCallsTop } from '../../components/Calls/CallsTop/IncomingCallsTop';
import { useIncomingCalls } from '../../hooks/components/useIncomingCalls/useIncomingCalls';
import { RightFilterPanel } from '../../components/shared/RightFilterPanel/RightFilterPanel';
import { TaskCampaignFilter } from '../../components/shared/TaskCampaignFilter';
import blockStyles from '../../components/Blocks/style.module.css';

export const IncomingCallsScreen: FC = memo(() => {
  const propsIncomingCalls = useIncomingCalls();
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  const handleToggleFilters = () => {
    setIsFiltersOpen((prev) => !prev);
  };

  return (
    <Blocks
      topBlock={
        <div className={blockStyles.topBlockGrid}>
          <SiteMenu
            title="Журнал входящих заданий"
            svg={true}
            svgType="incomingCalls"
          />

          <IncomingCallsTop
            onSearch={propsIncomingCalls.handleSearch}
            onRangePicker={propsIncomingCalls.handleRangePicker}
            dateRange={propsIncomingCalls.dateRange}
            onOkReport={propsIncomingCalls.handleOkReport}
            onToggleFilters={handleToggleFilters}
            isFiltersOpen={isFiltersOpen}
            isReportLoading={propsIncomingCalls.isReportLoading}
            activeFilterCount={propsIncomingCalls.activeFilterCount}
            disabled={propsIncomingCalls.isFilterLoading}
          />
        </div>
      }
      mainBlock={
        <IncomingCalls
          key="incoming"
          pageSize={propsIncomingCalls.pageSize}
          totalCount={propsIncomingCalls.totalCount}
          onChange={propsIncomingCalls.handleChange}
          onTableChange={propsIncomingCalls.onTableChange}
          callRequest={propsIncomingCalls.callRequest}
          total={propsIncomingCalls.total}
          allCalls={propsIncomingCalls.allCalls}
          COLUMNS={propsIncomingCalls.COLUMNS}
          divider={propsIncomingCalls.divider}
          handlePageSizeChange={propsIncomingCalls.handlePageSizeChange}
          filtersCollapsed={!isFiltersOpen}
          scenarioLabelByType={propsIncomingCalls.scenarioLabelByType}
          resultLabelByValue={propsIncomingCalls.resultLabelByValue}
          loading={propsIncomingCalls.isTableLoading}
          hasLoadError={propsIncomingCalls.hasLoadError}
        />
      }
      rightBlockOpen={isFiltersOpen}
      reserveRightSpace={true}
      rightBlockWidth={300}
      rightBlock={
        <RightFilterPanel
          onReset={propsIncomingCalls.resetFilters}
          onClose={handleToggleFilters}
          resetDisabled={
            propsIncomingCalls.isResetDisabled ||
            propsIncomingCalls.isFilterLoading
          }
        >
          <IncomingCallsFilter
            campaignFilter={
              <TaskCampaignFilter
                {...propsIncomingCalls.campaignFilter}
                disabled={propsIncomingCalls.isFilterLoading}
              />
            }
            clinics={propsIncomingCalls.clinics}
            filterOption={propsIncomingCalls.filterOption}
            clinicValue={propsIncomingCalls.clinicValue}
            onClinicsChange={propsIncomingCalls.handleClinicsChange}
            onOpenClinics={propsIncomingCalls.handleOpenClinics}
            resultValue={propsIncomingCalls.resultValue}
            onResultChange={propsIncomingCalls.handleResultChange}
            onOpenResult={propsIncomingCalls.handleOpenResult}
            attemptStatusValue={propsIncomingCalls.attemptStatusValue}
            onAttemptStatusChange={propsIncomingCalls.handleAttemptStatusChange}
            onOpenAttemptStatus={propsIncomingCalls.handleOpenAttemptStatus}
            scenarioValue={propsIncomingCalls.scenarioValue}
            onScenarioChange={propsIncomingCalls.handleScenarioChange}
            onOpenScenario={propsIncomingCalls.handleOpenScenario}
            resultOptions={propsIncomingCalls.resultOptions}
            scenarioOptions={propsIncomingCalls.scenarioOptions}
            disabled={propsIncomingCalls.isFilterLoading}
          />
        </RightFilterPanel>
      }
    />
  );
});

IncomingCallsScreen.displayName = 'IncomingCallsScreen';
